module.exports = __webpack_public_path__ + "img/20.0a9fef8c.png";